<app-ep-generic-dialog [dialogTitle]="title" (cancelClick)="cancel()">
  <ng-container dialog-content>
    <div class="dialog-content">
      <div [innerHTML]="description"></div>
      <app-ep-checkbox [(ngModel)]="hasAccepted">{{ terms }}</app-ep-checkbox>
    </div>
  </ng-container>

  <ng-container dialog-actions>
    <div class="button-container">
      <button class="ep-btn ep-btn-primary" [disabled]="!hasAccepted" (click)="acceptTerms()">
        {{ confirmText }}
      </button>
    </div>
  </ng-container>
</app-ep-generic-dialog>
